export default "__VITE_ASSET__DcW9$9X0__"